module.exports = __webpack_public_path__ + "img/pay_icon1.841187e0.png";